module.exports = __webpack_public_path__ + "img/svg/padlock.66bf484eba02b0cf1c79d3f3d82e57ef.svg";